import { formatDate } from "@core/utils/date";

type FormattedDateProps = {
  date?: string | Date;
  displayType?: "table" | "details" | "badge";
};

export function FormattedDate({
  date,
  displayType = "table",
}: FormattedDateProps) {
  const formatted = formatDate(date ?? new Date());

  const [datePart, timePart] = formatted
    .split(" ")
    .reduce<string[]>((acc, part) => {
      if (part.includes(":")) acc[1] = part;
      else acc[0] = acc[0] ? acc[0] + " " + part : part;
      return acc;
    }, []);

  return (
    <div className="flex items-center min-w-0 gap-2">
      <span
        className={`truncate text-sm ${
          displayType === "table" ? "text-neutral-500" : "text-neutral-400"
        }`}
        title={datePart}
      >
        {datePart}
      </span>

      {displayType === "table" && (
        <span className="shrink-0 text-sm ttext-neutral-400" title={timePart}>
          {timePart}
        </span>
      )}
    </div>
  );
}
